import { Divider, Tab, Tabs } from '@mui/material';
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/organisms/page/page';

export const SpacesContainer = () => {
  const { t } = useTranslation(['spaces', 'spaceGroups']);
  const location = useLocation();

  const tabs = [
    {
      href: '/tenant/spaces',
      label: t('spaces:common.tabs.listView'),
    },
    {
      href: '/tenant/spaces/floor-planner',
      label: t('spaces:common.tabs.mapEditor'),
    },
    {
      href: '/tenant/spaces/groups',
      label: t('spaceGroups:common.title'),
    },
  ];

  const activeTabIndex = tabs.findIndex(tab =>
    tab.href.includes(location.pathname),
  );

  return (
    <Page>
      <Tabs
        allowScrollButtonsMobile
        sx={{ mt: 4 }}
        value={activeTabIndex === -1 ? 0 : activeTabIndex}
        variant="scrollable">
        {tabs.map(option => (
          <Tab
            component={Link}
            key={option.href}
            label={option.label}
            to={option.href}
          />
        ))}
      </Tabs>
      <Divider />
      <Outlet />
    </Page>
  );
};
